import { ControllerRenderProps, FieldValues } from 'react-hook-form';

import Input from '../../../Input';
import { IBaseField, IInputField } from "../../types";
import WrapperFormField from '../WrapperFormField';

type InputFieldProps = IBaseField &
  IInputField & {
    field: ControllerRenderProps<FieldValues, string>;
    status?: 'primary' | 'error';
    password?: boolean;
    beforeInput?: React.ReactNode;
    afterInput?: React.ReactNode;
    classes?: {
      classNameBeforeInput?: string;
      classNameAfterInput?: string;
    };
  };

  const InputField: React.FunctionComponent<InputFieldProps> = ({
    name,
    label,
    field,
    placeholder,
    status,
    password,
    beforeInput,
    afterInput,
    onlyNumber,
    ...rest
  }) => {
    return (
      <WrapperFormField
        label={label}
        status={status}
        {...rest}
      >
        <Input
          {...field}
          placeholder={placeholder}
          error={status === 'error'}
          type={password ? 'password' : 'text'}
          key={name}
        />
      </WrapperFormField>
    );
  };
  
  export default InputField;